import React, { Component } from 'react';
import {
    getTitleTable, columnsTable,
    getDataSource,
    customOptionSelectHMS
} from '../../../../../../helpers/functions';

import { ListComponent } from '../../../../common/component/Index';
// import './RedeemtionDetail.less';

let permisionActions = [];
const defaultState = {};

const Cols = [
    'groupCode', 'groupName', 'quantity',
];
export default class AgentListReports extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ...defaultState,
            titleItemTable: getTitleTable(Cols, [], []),
            modelItem: Cols,
            componentTable: {
                groupCode: {
                    key: 'groupCode',
                    width: 140,
                    fixed: 'left',
                },
                groupName: {
                    key: 'groupName',
                    width: 450,
                    fixed: 'left',
                },
                quantity: {
                    sorter: (i, k) => i.quantity.length - k.length,
                    key: 'quantity',
                    align: 'center',
                },
            },
        };
    }

    render() {
        const { data, loading } = this.props;
        const { items } = data;
        const { titleItemTable, modelItem, componentTable } = this.state;

        return (
            <ListComponent
                scroll={{ x: 690 }}
                classParent="m-0 p-0 col-md-12" classChildren="m-0 p-0"
                marginTop={'0'} marginBottom={'0'}
                loading={{ spinning: loading, size: 'large' }}
                rowKey={(record, k) => record.groupId ? record.groupId : k}
                dataSource={getDataSource(items || [], modelItem)}
                columns={columnsTable({
                    titleTable: titleItemTable,
                    component: componentTable,
                    itemName: 'report'
                })}
                pagination={{ total: data.totalCount, totalPage: data.totalPage, current: data.pageIndex, pageSize: data.pageSize }}
                onChange={this.props.onTableChange}
                componentTableList={{}}
                hideSettings={true}
            />
        );
    }

}

AgentListReports.defaultProps = {
    data: {},
    filters: {},
    loading: false,
    onTableChange: () => { },
}

